export default "{\n    \"label\": \"Moneda\"\n}\n"